<template>
  <div style="height:94%;">
    <div class="search-bar-comm-style">
      <input
            type="text"
            v-model="search"
            class="rounded text-light search-bar"
            :placeholder="$t('Search plugin')"/>
    </div>
    <div class="pt-0 pb-2" style="height:86%;overflow:auto;float: inline-start;width:100%">
      <table class="table users-basic-info-table"  style="background: transparent;width: 94%;margin: 0px 3%;">
        <tbody>
            <template v-for="plugin in filteredPlugins">
              <tr  :key="plugin.plugin_id">
                <td style="position:relative;inset-inline-start:0px;top:10%">
                  <div style="height:70px;width:110px">
                  <img :src="plugin.thumbnail_path" @error="replaceByDefaultImage" alt="icon" class="h-100 w-100" style="border-radius: 10px"/>
                  </div>
                </td>
                <td class="key-div p-2" style="width: 70%">
                  <div class="d-inline-flex float-left w-100">
                    <div style="text-align:start;color:#fff;font-weight:500;font-size:28px"> {{ plugin.plugin_name }}</div>
                    <div style="min-width:13%;max-width:30%;text-align:start;padding:9px;position:relative;top:3px;color:#b2b2b2"><span style="font-size:16px;color:#b2b2b2">v-</span> 
                    <select v-if="!plugin.existing_plugin_status.upgrade_status || !plugin.existing_plugin_status.installation_pending" class="bg-transparent rounded" style="font-size:14px;color:#b2b2b2" @change="updatePluginSelectedVersion($event,plugin.plugin_id,plugin.existing_plugin_status.installed_version)">
                      <option v-for="(versions,index) in plugin.plugin_versions"
                        :selected="versions.version == getPreviousVersion(plugin)"
                        :key="index" :value="versions.version">{{versions.version}}</option>
                    </select>
                    </div>
                    <div style="text-align:start;margin-top:5px;" class="freeVersion" :class="{greenText:plugin.type == 'free'}"> {{plugin.type}}</div>
                  </div>
                  <div style="text-align:start;margin-top:5px;text-transform: uppercase;color: #9a7d7d"> {{plugin.category}}</div>
                  <div style="text-align:start;margin-top:5px;"><div v-if="subText && plugin.description.length > 250">{{plugin.description.substring(0,250)}}...<span @click="seeMore()"><b style="color:#bdbdbd">See more</b></span></div><div v-else>{{plugin.description}}</div></div>
                </td>
                <td class="value-div d-flex m-0" style="float:inline-end;position:relative;width:70%;justify-content: center">
                  <span v-if="downgradeUnSupportedList.includes(plugin.plugin_id)" class="text-danger" style="position:absolute">
                    {{$t('Version downgrade is not suported')}}
                  </span>
                  <button v-else-if="plugin.existing_plugin_status.upgrade_status"
                  style="width:120px;height:36px"  class="btn btn-outline-warning mt-1"
                    @click="UpgradePlugin(plugin.plugin_id)">
                    <span>{{$t('UPGRADE')}}</span>
                  </button>
                  <button v-else-if="plugin.existing_plugin_status.installation_pending" style="width:120px;height:36px"  class="btn btn-outline-primary mt-1"
                    @click="pluginInstallation(plugin.plugin_id)">
                    <span>{{$t('INSTALL')}}</span>
                  </button>
                  <!-- <button v-else type="button" style="width:120px;height:36px"  class="btn btn-outline-primary mt-1 ml-2"> -->
                    <span v-else style="color:#35AC19;position: relative;">{{$t('INSTALLED')}}</span>
                  <!-- </button> -->
                </td>
              </tr>
            </template>
        </tbody>
      </table>
    </div>
 </div>
</template>

<script>
import { mapActions, mapMutations } from "vuex";
import Utils from "../../components.utils.js";
import Constants from "../../components.constants.js";

// import axios from "axios";

export default {
  data() {
    return {
        subText:true,
        installNewPlugin:[],
        cachedSelectedPluginVersions:[],
        downgradeUnSupportedList:[],
        search: null,
        currentHost: window.location.host
    };
  },
  components: {
  },
  props: ["fileInfo","refreshFileInfoAndShowAsset"],
  emits: ["close"],
  methods: {
    replaceByDefaultImage(e){
      e.target.onerror = null
      e.target.src = Utils.getNoThumbnailImg();
    },
    clickCategoryBrowse() {
      this.$emit("close");
    },
    seeMore(){
      this.subText = false;
    },
    updatePluginSelectedVersion(event,pluginId, installedVersion){
      let selectedPlugin = this.installNewPlugin.filter(plugin => plugin.plugin_id == pluginId) 
      if(selectedPlugin == undefined){
        return
      }
      let pluginVersionInfo = selectedPlugin[0].plugin_versions.filter(versionInfo => versionInfo.version == event.target.value)
      if(pluginVersionInfo != undefined || pluginVersionInfo.length > 0){
        this.cachedSelectedPluginVersions[pluginId] = pluginVersionInfo[0];
        if((event.target.value < installedVersion) && installedVersion.trim().length > 0){
          if (!this.downgradeUnSupportedList.includes(pluginId) ){
            this.downgradeUnSupportedList.push(pluginId)
          }
        }else{
          this.downgradeUnSupportedList.splice(this.downgradeUnSupportedList.indexOf(pluginId),1)
        }
      }
    },
    isUpdatedVersionAvailable(pluginId){
      let selectedPlugin = this.installNewPlugin.filter(plugin => plugin.plugin_id == pluginId) 
      let installedVersion = "0"
      let majorVersion = "0"
      if(typeof selectedPlugin != "undefined" && selectedPlugin.length > 0){
      let  pluginInfo = selectedPlugin[0];
      if(pluginInfo.existing_plugin_status.installed_version.trim().length > 0){
        installedVersion = pluginInfo.existing_plugin_status.installed_version
      }
      let pluginVersionInfo = pluginInfo.plugin_versions;
      if(pluginVersionInfo != undefined || pluginVersionInfo.length > 0){
        let lastVersions = pluginVersionInfo[pluginVersionInfo.length - 1]
        majorVersion = lastVersions.version;
      }
      }
      if(installedVersion == "0"){
        return true
      }
      return majorVersion > installedVersion
    },
    UpgradePlugin(pluginId){
      let payload = {};
      let pluginInfo = {};
      let selectedPlugin = this.installNewPlugin.filter(plugin => plugin.plugin_id == pluginId) 
          if(selectedPlugin == undefined || selectedPlugin.length <= 0){
            return
      }
      pluginInfo = selectedPlugin[0];
      if(this.cachedSelectedPluginVersions[pluginId] == undefined){
          let pluginVersionInfo = pluginInfo.plugin_versions;
          if(pluginVersionInfo != undefined || pluginVersionInfo.length > 0){
            pluginInfo.plugin_version = pluginVersionInfo[pluginVersionInfo.length - 1];
          }
      }else{
        pluginInfo.plugin_version = this.cachedSelectedPluginVersions[pluginId]
      }
      for(let key in pluginInfo){
        if(["category","plugin_id","plugin_name","plugin_name","plugin_version"].includes(key)){
          payload[key] = pluginInfo[key]; 
        }
      }
      payload.command = "PLUGIN_UPGRADE"
      this.upgradeExistingPlugin(payload).then((data)=>{
          if (Utils.isAcceptedStatusCode(data.statusCode)) {
            this.$toast.success(data.message);
            this.getPluginsRepoFromServer();
          } else {
            this.$toast.error(data.message);
          }
        });
    },
    pluginInstallation(pluginId){
      let payload = {};
      let pluginInfo = {};
      let selectedPlugin = this.installNewPlugin.filter(plugin => plugin.plugin_id == pluginId) 
          if(selectedPlugin == undefined || selectedPlugin.length <= 0){
            return
      }
      pluginInfo = selectedPlugin[0];
      if(this.cachedSelectedPluginVersions[pluginId] == undefined){
          let pluginVersionInfo = pluginInfo.plugin_versions;
          if(pluginVersionInfo != undefined || pluginVersionInfo.length > 0){
            pluginInfo.plugin_version = pluginVersionInfo[pluginVersionInfo.length - 1];
          }
      }else{
        pluginInfo.plugin_version = this.cachedSelectedPluginVersions[pluginId]
      }
      for(let key in pluginInfo){
        if(key != "plugin_versions"){
          payload[key] = pluginInfo[key]; 
        }
      }
      payload.command =  "PLUGIN_INSTALL"
      this.installPlugin(payload).then((data)=>{
          if (Utils.isAcceptedStatusCode(data.statusCode)) {
            this.$toast.success(data.message);
            this.getPluginsRepoFromServer();
          } else {
            this.$toast.error(data.message);
          }
        });
    },

    updateNewInstalledPluginInStore(notification){
      notification = notification.detail && Object.keys(notification.detail).length!=0?notification.detail:notification
      var pluginStatusData = notification.message.existing_plugin_status;
      let selectedPlugin = this.installNewPlugin.filter(plugin => plugin.plugin_name == notification.message.plugin_name)
        if(selectedPlugin  != undefined){
          selectedPlugin[0].existing_plugin_status = pluginStatusData;
        }
        
      this.filteredPlugins();  
    },

    updateUnInstalledPluginInStore(notification){
      notification = notification.detail && Object.keys(notification.detail).length!=0?notification.detail:notification
      var pluginStatusData = notification.message.existing_plugin_status;
      let selectedPlugin = this.installNewPlugin.filter(plugin => plugin.plugin_name == notification.message.plugin_name)
          if(selectedPlugin  != undefined){
            selectedPlugin[0].existing_plugin_status = pluginStatusData;
          } 
    },
    getPreviousVersion(instPlugin){
      let preVersion = ""
      let pluginStatus = instPlugin.existing_plugin_status
      if(pluginStatus && pluginStatus.installed_version && pluginStatus.installed_version.trim().length > 0){
        preVersion = pluginStatus.installed_version
      }else{
        let avlVersions = instPlugin.plugin_versions
        if(avlVersions && Array.isArray(avlVersions) && avlVersions.length > 0){
          let lastVersion = avlVersions[avlVersions.length - 1]
          if(lastVersion){
            preVersion = lastVersion.version
          }
        }
      }
      return preVersion;
    },
    ...mapActions("pluginRepo", ["getPluginsRepoFromServer","getInstalledPluginsFromServer","installPlugin","upgradeExistingPlugin"]),
    ...mapMutations("websocket",["addWSEventListener", "removeWSEventListener"]),
  },
  computed: {
    filteredPlugins() {
      if(this.search != null){
        if (!this.installNewPlugin.length) {
            return [];
        }
        return this.installNewPlugin.filter((item) => {
            const pluginName = item.plugin_name.toLowerCase();
            const searchTerm = this.search.toLowerCase();
            return pluginName.includes(searchTerm);
        });
      }else{
          return this.installNewPlugin;
      }
    } 
  },
  created(){
    this.getPluginsRepoFromServer().then((data) => {
        this.installNewPlugin = data.plugins;
    });
    
    this.addWSEventListener({eventname:Constants.plugininstalledNotificationinspluginStore, callback:this.updateNewInstalledPluginInStore, parent:"addPlugins"}); 
    this.addWSEventListener({eventname:Constants.pluginupgradedNotification, callback:this.updateNewInstalledPluginInStore, parent:"addPlugins"}); 
    this.addWSEventListener({eventname:Constants.pluginUninstalledNotificationpluginStore, callback:this.updateUnInstalledPluginInStore, parent:"addPlugins"}); 
  },
  beforeDestroy(){
    this.removeWSEventListener({eventname:Constants.plugininstalledNotificationinspluginStore, callback:this.updateNewInstalledPluginInStore, parent:"addPlugins"}); 
    this.removeWSEventListener({eventname:Constants.pluginupgradedNotification, callback:this.updateNewInstalledPluginInStore, parent:"addPlugins"}); 
    this.removeWSEventListener({eventname:Constants.pluginUninstalledNotificationpluginStore, callback:this.updateUnInstalledPluginInStore, parent:"addPlugins"}); 
  }
};
</script>

<style scoped lang="scss">
    $border-color: 1px solid #4a4a4a;
    $border-color-only:#4a4a4a;
    $primary-background: #1a1e21;
    $secondary-background-color:#15181B;
    $bg-color-on-hover: #22272b;
    $text-color: #eee;
    $dull-text-color: #757575;
    $secondary-text-color: #9c9c9c;
    $active-blue : #007bff;
    $input-field-and-label-font-size:14px;
    $danger-color: #dc3545 !important;
    $input-field-height:38px;
    $none-text-color:#4f4f4f;
    $input-field-padding:.375rem 10px;
    $scrollbar-thumb-background:#333;
    $scrollbar-track-background:#1a1e21;
    $scrollbar-thumb-on-hover-background:#555;
    $tags-background-color:#282d31;
    $tags-border-color:#363636;
    $metadata-border-color-on-hover: #5a5a5a;
    $secondary-border-color: 1px solid #2b2b2b;
    $active-green-color:#28a745;
    $svg-color:#666;
    $learn-about-text-color-hover:#b7b327;
    $active-green-icon-color: #00ff3a;
    $learn-about-text-color:#9a9620;

.validationmessage{
  color:$danger-color;
  font-size: 11px;
}
.modal-dialog {
  width: calc(100vw - 200px);
  height: calc(100vh - 300px);
  max-width: 100%;
  margin: 0;
  padding: 0;
}

.modal-content {
  height: auto;
  min-height: 100%;
  border: 0 none;
  border-radius: 0;
  box-shadow: none;
  background: $primary-background !important;
  border: $border-color;
  .modal-body {
    background: $primary-background;
    height: 300px;
    overflow: auto;
  }
}
.modal.fade{
    opacity:0;
}
.search-bar-comm-style{
  height:30px;
  position:relative;
  // padding-top: 12px;
  margin:20px;
  input{
    border:$border-color;
    height: 25px;
    padding-inline-start: 3%;
  }
  svg{
    position: absolute;
    inset-inline-start:21px;
    top: 58%;
  }
}


.modal {
  text-align: center;
  padding: 0 !important;
  display: block;
}
.modal:before {
  content: "";
  display: inline-block;
  height: 100%;
  vertical-align: middle;
  margin-inline-end: -4px;
}
.modal-dialog {
  display: inline-block;
  text-align: start;
  vertical-align: middle;
}

.modal-footer {
  justify-content: start;
}

.btn {
  font-size: 14px !important;
  height: 100%;
}

.border {
  border: $border-color !important;
}

.modal-header,
.modal-footer {
  border: none !important;
  background: $secondary-background-color;
  .modal-title {
    color: $text-color;
  }
}
.activeclass {
  color: $active-blue;
}

.primary-btn-style {
  margin-top: 1%;
  height:55px;
  button {
    height: 35px;
    width: 70px;
    border-radius: 16px;
  }
}

.secondary-btn-style {
  color: $text-color;
}

.secondary-btn-style:hover{
  text-decoration: underline;
}

.users-basic-info-table {
  font-size: 15px;
  tbody {
    margin: 10px;
    .key-div {
      text-align: end;
      color: $secondary-text-color;
    }
    .value-div {
      text-align: start;
      margin-inline-start: 10px;
    }
  }
}

table {
  background: transparent;
  thead {
    th {
      color: $dull-text-color;
      border-top: none !important;
      border-bottom: none !important;
    }
  }
  tbody {
    color: $text-color;
    tr{
      height:140px;
      border-bottom:1px solid #202020;
      td {
            border-top: none !important;
        }
    }
  }
}

/* width */
::-webkit-scrollbar {
  width: 8px;
}

/* Track */
::-webkit-scrollbar-track {
  background: $scrollbar-track-background;
}

/* Handle */
::-webkit-scrollbar-thumb {
  background: $scrollbar-thumb-background;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: $scrollbar-thumb-on-hover-background;
}


.greenText{
    width: auto;
    border: 2px solid #438709 !important;
    border-radius: 8px;
    padding: 0px 9px !important;
    color: #54a312 !important;
    font-size: 11px;
    text-transform: uppercase;
    height:18px;
    position:relative;
    top:7px;
}
.freeVersion{
    width: auto;
    border: 2px solid #a6a600;
    border-radius: 8px;
    padding: 0px 9px;
    color: #a6a600;
    font-size: 11px;
    text-transform: uppercase;
    height:18px;
    position:relative;
    top:7px;
}

.modal-header .close {
    // margin: -1rem -13px -1rem auto !important;
    margin:0px !important;
    padding: 0px !important;
}
.search-bar-comm-style {
    // inset-inline-end :16px;
    height: 50px;
    position: relative;
    // bottom: 11px;
  .search-bar{
    background: $primary-background!important;
    height:40px;
    width: 250px !important;
    float: inline-start;
    // margin-inline-start: 3%;
    padding-inline-start: 12px;
    padding-bottom: 2px;
    border: $border-color !important;
  }
}
</style>